// extracted by mini-css-extract-plugin
module.exports = {"cross":"cross___aLxmh","textContainer":"textContainer___28N70","wrapper":"wrapper___1B-k6"};